export function trackPendoEvent(eventName: string, data?: Record<string, unknown>) {
  if (window.pendo) {
    window.pendo.track(eventName, data);
  }
}
